module.exports = __webpack_public_path__ + "img/blanco.9a2588c5.png";